<div edsRow>
  <div class="subscription-products__header">
    <div class="subscription-products__header-title">
      {{ "subscriptions.products-header-title" | translate }}
    </div>
    <div
      class="subscription-products__header-content"
      *ngIf="(!globalUnsubscribe && loggedIn) || isLoading"
    >
      {{ "subscriptions.products-header-content" | translate }}
    </div>
  </div>
</div>
<div
  edsRow
  class="subscription-products__filter"
  [class.subscription-products__filter--disabled]="isLoading"
>
  <!-- Filters -->
  <ng-container *ngFor="let filter of filterTypes; let i = index">
    <ng-container *ngIf="filter.options.length > 0">
      <eds-dropdown
        edsCol
        edsSpacing="md"
        ariaLabel="Dropdown"
        [ngClass]="'filter'"
        [columnNumbers]="{ s: 4, m: 3, l: 2 }"
        [theme]="'dark'"
        [label]="'subscriptions.filter-' + filter.label | translate"
        [titleText]="' '"
        [items]="filter.options"
        [required]="false"
        [multi]="filter?.type?.key !== 'PRODUCTS'"
        [showCount]="true"
        [alignment]="'left'"
        [preselectedValue]="filter.preSelectedValues"
        [selectedText]="'subscriptions.filter-selected' | translate"
        (dropdownChange)="updateFilter(filter.label, $event)"
        eventType="form_filter"
      ></eds-dropdown>
    </ng-container>
  </ng-container>
  <!-- Search -->
  <ng-container>
    <eds-search
      *ngIf="rowData"
      edsCol
      edsSpacing="md"
      [columnNumbers]="{ s: '4', m: 'auto', l: 'auto' }"
      placeholder="{{ 'subscriptions.filter-search' | translate }} {{
        filterTypes[0].preSelectedValues['label']
      }}"
      fieldId="search__field"
      [value]="textFilterValue"
      (searchTerm)="searchByKeyword($event)"
    ></eds-search>
  </ng-container>
</div>

<div edsRow *ngIf="(!globalUnsubscribe && loggedIn) || isLoading">
  <div class="subscription-products__counting">
    <span>
      {{ "subscriptions.counting-shows" | translate }}
    </span>
    <!-- Spinner -->
    <span class="subscription-products__loader" *ngIf="isLoading">
      <ngx-spinner
        name="countLoadingSpinner"
        bdColor="rgba(0,0,0,0)"
        size="small"
        color="#000"
        type="line-scale-party"
        [fullScreen]="false"
      >
      </ngx-spinner>
    </span>
    <span *ngIf="!isLoading">
      <span class="subscription-products__counting-number">{{
        records.showed
      }}</span>
      <span>
        {{ "subscriptions.counting-of" | translate }}
      </span>
      <span class="subscription-products__counting-number">{{
        records.all
      }}</span>
      <span
        *ngIf="resetFilterButton"
        class="subscription-products__reset-filters"
      >
        <eds-link-item
          edsFlexbox
          justifyContent="flex-end"
          theme="basic"
          [title]="'subscriptions.reset-filters' | translate"
          [hasIcon]="true"
          type="reset"
          (click)="resetFilters($event)"
          class="text-primary"
        ></eds-link-item>
      </span>
    </span>
  </div>
  <div *ngIf="rowData" class="subscription-products__sorting-toggles-box">
    <div class="subscription-products__sorting-toggle">
      <span>{{ "subscriptions.show-subscriptions-only" | translate }}</span>
      <eds-switch
        [switchId]="'show-subscriptions-only'"
        labelOff="{{ 'subscriptions.off' | translate }}"
        labelOn="{{ 'subscriptions.on' | translate }}"
        class="subscription-products__filter"
        [class.subscription-products__filter--disabled]="isLoading"
        [state]="subscriptionOnlyState"
        (switchPressed)="toggleSubscriptionsOnly($event)"
      ></eds-switch>
    </div>
  </div>
</div>
<div edsRow *ngIf="!loggedIn" class="subscription-products__global-unsubscribe">
  {{ "subscriptions.login-note" | translate }}
</div>
<div
  edsRow
  *ngIf="globalUnsubscribe && !isLoading"
  class="subscription-products__global-unsubscribe"
>
  {{ "subscriptions.global-unsubscribe-note" | translate }}
</div>
<form
  #subscriptionForm="ngForm"
  *ngIf="!globalUnsubscribe && loggedIn"
  class="subscription-products__form-data"
  [class.subscription-products__form-data--disabled]="isLoading"
>
  <div edsRow edsSpacing="md">
    <div edsCol>
      <ag-grid-angular
        #subscriptionProductsGrid
        class="ag-theme-frk subscription-products__ag-full-size"
        stickyHeader
        [rowData]="rowData"
        [columnDefs]="columnDefs"
        [defaultColDef]="defaultColDef"
        [multiSortKey]="'ctrl'"
        [getRowNodeId]="getRowNodeId"
        [frameworkComponents]="frameworkComponents"
        [rowSelection]="'multiple'"
        [paginationPageSize]="10"
        [pagination]="true"
        [suppressPaginationPanel]="false"
        [suppressHorizontalScroll]="true"
        [suppressRowClickSelection]="true"
        [isExternalFilterPresent]="isExternalFilterPresent"
        [doesExternalFilterPass]="doesExternalFilterPass"
        [getRowHeight]="getRowHeight"
        domLayout="autoHeight"
        [suppressRowHoverHighlight]="true"
        [suppressCellSelection]="false"
        [ensureDomOrder]="true"
        [cacheQuickFilter]="true"
        (firstDataRendered)="onFirstDataRendered($event)"
        (gridReady)="onGridReady($event)"
        [enableCellTextSelection]="true"
        overlayNoRowsTemplate="<p class='subscription-products__no-rows'> {{
          'subscriptions.no-data' | translate
        }}</p>"
        overlayLoadingTemplate="<p class='subscription-products__no-rows'> {{
          'subscriptions.load-data' | translate
        }}"
      >
      </ag-grid-angular>
    </div>
  </div>
  <eds-sticky-footer
    [itemCount]="selectedItemsCount"
    [label]="'subscriptions.updated-items' | translate"
    [isHide]="selectedItemsCount === 0 && !hasSubscriptions"
    [showCounting]="selectedItemsCount > 0"
    [primaryAction]="{
      hasAction: true,
      isDisabled: isDisabledSubject$ | async,
      buttonLabel: 'subscriptions.save-updates' | translate
    }"
    (btnSubscribePrimary)="submitSubscriptions()"
    [stickyFooterName]="'submit_sticky_footer'"
  ></eds-sticky-footer>
</form>
